import React, { Component } from "react";
import { Form, Label } from 'semantic-ui-react'

export default class DropDown extends Component {
  constructor(props)
  {
    super(props);
    this.onValueChange= this.onValueChange.bind(this);
    this.state = {textValue: this.props.value, isError: false, errorText: ""};

  }

  componentDidMount()
  {
    var values
    if ('filtervalue' in this.props)
    {
      values=this.props.values[this.props.filtervalue]
    }
    else
    {
      values=this.props.values 
    }
    this.setState({values: values})
  }


  componentWillReceiveProps(nextProps)
  {
    var values
    if ('filtervalue' in nextProps)
    {
      if(this.props.filtervalue != nextProps.filtervalue)
      {
      values=this.props.values[nextProps.filtervalue]
      this.setState({values: values})
      }
    }

  }

  onValueChange(event, data)
  {
    const newValue=data.value;
    const field=this.props.field;
    var isError=false
    var errorText=""
  
    //validation
    console.log(newValue)
    if(!field.nullable && newValue===null)
    {
      isError=true;
      errorText="Required"      
    }
    this.setState({textValue: newValue, isError: isError, errorText: errorText})
    this.props.onChange(this.props.fieldname, this.props.field, newValue, !isError)
  }

  render() {
    var value=this.props.enabled ? this.props.value : this.props.nullifdisabled ? null : this.props.value;
    // call value change if different to what is held in SQL
    if (value!==this.props.value){
      this.onValueChange(null, {"value": value})
    }

    const showlabel=this.props.showlabel;
    const values=this.state.values;
    const showError=this.state.isError;


    if (this.props.showdescriptiononly && values)
      {
        for(var i=0;i<values.length;i++)
        {
          if(values[i].value===value)
            return values[i].text
        }
        return ""
      }
      else
      return (
          
        <Form.Field required={!this.props.field.nullable} >
        {showlabel && <label style={{color: this.props.darkmode ? "white": "black"}}>{this.props.field.label}</label>}
        <Form.Select value={value} options={values} onChange={this.onValueChange}  disabled={!this.props.enabled} search={this.props.search}/>
        {showError && <Label pointing>{this.state.errorText}</Label>}
        </Form.Field>
    )
    
      ;
  }
}